import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3994a914"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gantt-chart" }
const _hoisted_2 = { class: "f aic jcsb" }
const _hoisted_3 = { class: "mb-8 f aic" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Выполнение задач", -1))
const _hoisted_5 = { class: "f aic mb-4" }
const _hoisted_6 = { class: "zoom-level" }

import { ref, onMounted, watch, nextTick, computed } from "vue";
import {
  TirCheckbox,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmPopover,
  TirPmScrollbar,
} from "tir-components";
import EnumJobStatus from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/database/enums/EnumJobStatus";
import JobTimelineItem from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/JobTimelineItem";
import JobTimeline from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/JobTimeline";
import {
  MinusIcon,
  PlusIcon,
  FunnelIcon,
} from "tir-style-system/icons/outline";
import PopoverOptionList from "@/components/sidebar/components/popover-option-list/popover-option-list.vue";
import PopoverOptionLi from "@/components/sidebar/components/popover-option-list/popover-option-li.vue";
import TirPmSearchInput from "tir-pm-search-input/src/TirPmSearchInput.vue";

const baseHourWidth = 24;
const leftPadding = 180;


export default /*#__PURE__*/_defineComponent({
  __name: 'gantt-chart',
  props: {
    tasks: {},
    startDate: {},
    endDate: {},
    timeZone: {}
  },
  emits: ["update:onlyError", "task-clicked"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const STATUS_COLORS: Record<EnumJobStatus, string> = {
  [EnumJobStatus.Disabled]: "#660000",
  [EnumJobStatus.Wait]: "#cc5500",
  [EnumJobStatus.Queued]: "#365d6f",
  [EnumJobStatus.Preparing]: "#cc8400",
  [EnumJobStatus.RunWaiting]: "#009a9a",
  [EnumJobStatus.Running]: "#002eb8",
  [EnumJobStatus.Success]: "#29a329",
  [EnumJobStatus.Failed]: "#cc0000",
  [EnumJobStatus.Removed]: "#7a7a7a",
};

const STATUS_NAMES: Record<EnumJobStatus, string> = {
  [EnumJobStatus.Disabled]: "Отключено",
  [EnumJobStatus.Wait]: "Ожидание",
  [EnumJobStatus.Queued]: "В очереди",
  [EnumJobStatus.Preparing]: "Подготовка",
  [EnumJobStatus.RunWaiting]: "Ожидание запуска",
  [EnumJobStatus.Running]: "Выполняется",
  [EnumJobStatus.Success]: "Успешно",
  [EnumJobStatus.Failed]: "Ошибка",
  [EnumJobStatus.Removed]: "Удалено",
};





const canvas = ref<HTMLCanvasElement | null>(null);
const wrapper = ref<HTMLElement | null>(null);
const onlyError = ref(false);
const hoveredTask = ref<JobTimelineItem | null>(null);
const tooltipStyle = ref({ top: "0px", left: "0px" });
const activeTaskId = ref<string | null>(null);

// Зум
const zoomLevel = ref(1);
const hourWidth = computed(() => baseHourWidth * zoomLevel.value);

// Высота канваса
const canvasHeight = ref(400);
const minCanvasHeight = computed(() => 70 + filteredTasks.value.length * 50);
const $popoverJobFilter = ref<TirPmPopover | null>(null);
const searchJob = ref("");
const jobs = ref<{ JobId: string; JobName: string; IsSelect: boolean }[]>([]);

const selectedJobs = computed(() => jobs.value.filter((item) => item.IsSelect));
const noSelectJobs = computed(() =>
  jobs.value.filter((item) => !item.IsSelect)
);

watch(
  () => props.tasks,
  () => updateJobs(props.tasks)
);
onMounted(() => updateJobs(props.tasks));

const updateJobs = (value: JobTimeline[]) => {
  jobs.value = value.map((item) => ({
    JobId: item.JobId,
    JobName: item.JobName,
    IsSelect: false,
  }));
};

const onSelectJob = (item: any) => {
  item.IsSelect = !item.IsSelect;
  onFilteredTasks();
  drawChart();
};

const onSearchJob = (value: string) => {
  jobs.value = props.tasks.filter((item) =>
    item.JobName.toLowerCase().includes(value.toLowerCase())
  );
};

const onOpenPopoverJobFilter = () => {
  console.log("onOpenPopoverJobFilter");
};

const onClosePopoverJobFilter = () => {
  console.log("onClosePopoverJobFilter");
};

const handleWheel = (event: WheelEvent) => {
  if (event.ctrlKey) {
    event.preventDefault();
    const delta = event.deltaY > 0 ? -0.1 : 0.1;
    zoomLevel.value = Math.min(5, Math.max(0.5, zoomLevel.value + delta));
    drawChart();
  }
};

const zoomIn = () => {
  zoomLevel.value = Math.min(5, zoomLevel.value + 0.1);
  drawChart();
};

const zoomOut = () => {
  zoomLevel.value = Math.max(0.5, zoomLevel.value - 0.1);
  drawChart();
};

const filteredTasks = ref(props.tasks);

const onFilteredTasks = () => {
  if (!onlyError.value) {
    if (selectedJobs.value.length === 0) {
      filteredTasks.value = props.tasks;
    } else {
      filteredTasks.value = props.tasks.filter((task) =>
        selectedJobs.value.some((item) => item.JobId === task.JobId)
      );
    }
  } else {
    filteredTasks.value = props.tasks.filter((task) =>
      task.Executes.some((segment) => segment.Status === EnumJobStatus.Failed)
    );
  }
};

const daysRange = computed(() => {
  const start = new Date(props.startDate);
  start.setHours(0, 0, 0, 0);
  const end = new Date(props.endDate);
  end.setHours(23, 59, 59, 999);
  const days = [];
  let current = new Date(start);

  while (current <= end) {
    days.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }
  return days;
});

const totalHours = computed(
  () => (props.endDate.getTime() - props.startDate.getTime()) / (1000 * 60 * 60)
);

const getStatusName = (status: EnumJobStatus) => {
  return STATUS_NAMES[status] || `Статус ${status}`;
};

const startResize = (event: MouseEvent) => {
  event.preventDefault();
  const startY = event.clientY;
  const startHeight = canvasHeight.value;

  document.body.style.cursor = "ns-resize";

  const onMouseMove = (moveEvent: MouseEvent) => {
    const newHeight = startHeight + (moveEvent.clientY - startY);
    canvasHeight.value = Math.max(200, newHeight);

    if (wrapper.value) {
      wrapper.value.style.height = `${canvasHeight.value}px`;
    }
    if (canvas.value) {
      canvas.value.height = canvasHeight.value;
    }
    drawChart();
  };

  const onMouseUp = () => {
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
    document.body.style.cursor = "";
  };

  document.addEventListener("mousemove", onMouseMove);
  document.addEventListener("mouseup", onMouseUp);
};

const drawChart = () => {
  if (!canvas.value || !wrapper.value) return;

  const ctx = canvas.value.getContext("2d");
  if (!ctx) return;

  const wrapperWidth = wrapper.value.clientWidth;
  const naturalWidth = daysRange.value.length * hourWidth.value * 24;
  const canvasWidth = Math.max(wrapperWidth, naturalWidth);
  const scaleFactor = canvasWidth / naturalWidth;

  const contentHeight = minCanvasHeight.value;
  canvas.value.width = canvasWidth;
  canvas.value.height = contentHeight;

  if (wrapper.value) {
    wrapper.value.style.height = `${Math.min(
      canvasHeight.value,
      contentHeight
    )}px`;
  }

  ctx.clearRect(0, 0, canvasWidth, contentHeight);

  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, canvasWidth, 70);

  daysRange.value.forEach((day, dayIndex) => {
    const dayX = leftPadding + dayIndex * hourWidth.value * 24 * scaleFactor;

    ctx.fillStyle = "#000";
    ctx.font = "bold 14px Arial";
    ctx.textAlign = "center";
    ctx.fillText(
      `${day.getDate().toString().padStart(2, "0")}.${(day.getMonth() + 1)
        .toString()
        .padStart(2, "0")}`,
      dayX + (hourWidth.value * 24 * scaleFactor) / 2,
      20
    );

    for (let hour = 0; hour < 24; hour++) {
      const hourX = dayX + hour * hourWidth.value * scaleFactor;
      ctx.strokeStyle = "#eee";
      ctx.beginPath();
      ctx.moveTo(hourX, 70);
      ctx.lineTo(hourX, contentHeight);
      ctx.stroke();

      ctx.fillStyle = "#666";
      ctx.font = "12px Arial";
      ctx.fillText(
        hour.toString(),
        hourX + (hourWidth.value * scaleFactor) / 2,
        50
      );
    }

    ctx.strokeStyle = "#ccc";
    ctx.beginPath();
    ctx.moveTo(dayX, 0);
    ctx.lineTo(dayX, contentHeight);
    ctx.stroke();
  });

  filteredTasks.value.forEach((task, index) => {
    const taskY = 70 + index * 50;

    if (task.JobId === activeTaskId.value) {
      ctx.fillStyle = "rgba(0, 0, 255, 0.1)";
      ctx.fillRect(0, taskY, canvasWidth, 50);
    }

    ctx.fillStyle = "#000";
    ctx.font = "14px Arial";
    ctx.textAlign = "right";
    ctx.fillText(
      task.JobName.slice(0, 20) + (task.JobName.length > 20 ? "..." : ""),
      175,
      taskY + 15
    );

    ctx.strokeStyle = "#ccc";
    ctx.beginPath();
    ctx.moveTo(0, taskY);
    ctx.lineTo(canvasWidth, taskY);
    ctx.stroke();
  });

  filteredTasks.value.forEach((task, taskIndex) => {
    const y = 70 + taskIndex * 50 + 10;

    task.Executes.forEach((segment) => {
      const dateRun1 = new Date(segment.DateRun);
      const dateCom1 = segment.DateComplete
        ? new Date(segment.DateComplete)
        : new Date();
      const timezoneOffset = dateRun1.getTimezoneOffset();
      const dateRun = new Date(dateRun1.getTime() - timezoneOffset * 60 * 1000);
      const dateComplete = new Date(
        dateCom1.getTime() - timezoneOffset * 60 * 1000
      );

      const startOffsetHours =
        (dateRun.getTime() - props.startDate.getTime()) / (1000 * 60 * 60);
      const durationHours =
        (dateComplete.getTime() - dateRun.getTime()) / (1000 * 60 * 60);

      const startX = Math.max(
        leftPadding,
        startOffsetHours * hourWidth.value * scaleFactor
      );
      const widthBar = Math.max(
        Math.min(
          durationHours * hourWidth.value * scaleFactor,
          canvas.value.width - startX
        )
      );

      ctx.fillStyle = STATUS_COLORS[segment.Status] || "#ccc";
      ctx.fillRect(startX, y, widthBar, 30);
    });
  });
};

const onOnlyError = (value: boolean) => {
  onlyError.value = value;
  emits("update:onlyError", value);
  onFilteredTasks();
  drawChart();
};

const handleMouseMove = (event: MouseEvent) => {
  if (!canvas.value || !wrapper.value) return;

  const rect = canvas.value.getBoundingClientRect();
  const x = event.clientX - rect.left + wrapper.value.scrollLeft; // Убираем leftPadding из x
  const y = event.clientY - rect.top + wrapper.value.scrollTop;

  const wrapperWidth = wrapper.value.clientWidth;
  const naturalWidth = daysRange.value.length * hourWidth.value * 24;
  const scaleFactor = Math.max(wrapperWidth, naturalWidth) / naturalWidth;

  hoveredTask.value = null;

  filteredTasks.value.forEach((task, taskIndex) => {
    const taskY = 70 + taskIndex * 50;
    if (y >= taskY + 10 && y <= taskY + 40) {
      // Учитываем высоту сегмента (30px + отступ 10px)
      task.Executes.forEach((segment) => {
        const dateRun1 = new Date(segment.DateRun);
        const dateCom1 = segment.DateComplete
          ? new Date(segment.DateComplete)
          : new Date();
        const timezoneOffset = dateRun1.getTimezoneOffset();
        const dateRun = new Date(
          dateRun1.getTime() - timezoneOffset * 60 * 1000
        );
        const dateComplete = new Date(
          dateCom1.getTime() - timezoneOffset * 60 * 1000
        );

        const startOffsetHours =
          (dateRun.getTime() - props.startDate.getTime()) / (1000 * 60 * 60);
        const durationHours =
          (dateComplete.getTime() - dateRun.getTime()) / (1000 * 60 * 60);

        const startX = Math.max(
          leftPadding,
          startOffsetHours * hourWidth.value * scaleFactor
        );
        const widthBar = Math.min(
          durationHours * hourWidth.value * scaleFactor,
          canvas.value.width - startX
        );

        if (x >= startX && x <= startX + widthBar) {
          hoveredTask.value = segment;
          hoveredTask.value.JobName = task.JobName;
          tooltipStyle.value = {
            top: `${event.clientY - rect.top - 10}px`,
            left: `${
              event.clientX - rect.left + wrapper.value.scrollLeft + 20
            }px`, // Учитываем прокрутку
          };
        }
      });
    }
  });
};

const handleClick = (event: MouseEvent) => {
  if (!canvas.value || !wrapper.value) return;

  const rect = canvas.value.getBoundingClientRect();
  const x = event.clientX - rect.left + wrapper.value.scrollLeft; // Убираем лишний leftPadding
  const y = event.clientY - rect.top + wrapper.value.scrollTop;

  const wrapperWidth = wrapper.value.clientWidth;
  const naturalWidth = daysRange.value.length * hourWidth.value * 24;
  const scaleFactor = Math.max(wrapperWidth, naturalWidth) / naturalWidth;

  filteredTasks.value.forEach((task, taskIndex) => {
    const taskY = 70 + taskIndex * 50;
    if (y >= taskY + 10 && y <= taskY + 40) {
      // Учитываем высоту сегмента
      activeTaskId.value = task.JobId;
      let clickedJobExecuteId: string | null = null;

      task.Executes.forEach((segment) => {
        const dateRun1 = new Date(segment.DateRun);
        const dateCom1 = segment.DateComplete
          ? new Date(segment.DateComplete)
          : new Date();
        const timezoneOffset = dateRun1.getTimezoneOffset();
        const dateRun = new Date(
          dateRun1.getTime() - timezoneOffset * 60 * 1000
        );
        const dateComplete = new Date(
          dateCom1.getTime() - timezoneOffset * 60 * 1000
        );

        const startOffsetHours =
          (dateRun.getTime() - props.startDate.getTime()) / (1000 * 60 * 60);
        const durationHours =
          (dateComplete.getTime() - dateRun.getTime()) / (1000 * 60 * 60);

        const startX = Math.max(
          leftPadding,
          startOffsetHours * hourWidth.value * scaleFactor
        );
        const widthBar = Math.min(
          durationHours * hourWidth.value * scaleFactor,
          canvas.value.width - startX
        );

        console.log(
          `Task: ${task.JobName}, Segment: ${
            segment.JobExecuteId
          }, x: ${x}, startX: ${startX}, endX: ${startX + widthBar}`
        );

        if (x >= startX && x <= startX + widthBar) {
          clickedJobExecuteId = segment.JobExecuteId;
          console.log(`Clicked segment: ${segment.JobExecuteId}`);
        }
      });

      emits("task-clicked", {
        jobId: task.JobId,
        jobExecuteId: clickedJobExecuteId,
      });
      drawChart();
    }
  });
};

const handleMouseLeave = () => {
  hoveredTask.value = null;
};

onMounted(() => {
  nextTick(() => drawChart());
});

watch(
  () => [
    props.tasks,
    props.startDate,
    props.endDate,
    onlyError.value,
    zoomLevel.value,
  ],
  () => {
    nextTick(() => drawChart());
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_unref(TirPmPopover), {
            ref_key: "$popoverJobFilter",
            ref: $popoverJobFilter,
            "custom-position": { left: `0rem`, top: `$el:height` },
            width: "400",
            onClose: onClosePopoverJobFilter,
            onOpen: onOpenPopoverJobFilter
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FunnelIcon), {
                class: "ml-4",
                style: {"width":"1rem"}
              })
            ]),
            content: _withCtx(() => [
              _createVNode(TirPmSearchInput, {
                style: {"width":"100%"},
                modelValue: searchJob.value,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((searchJob).value = $event)),
                  onSearchJob
                ],
                "is-with-popup": false,
                label: "Поиск по названию",
                placeholder: ""
              }, null, 8, ["modelValue"]),
              _createVNode(PopoverOptionList, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedJobs.value, (el) => {
                    return (_openBlock(), _createBlock(PopoverOptionLi, {
                      onClick: _withModifiers(onSelectJob, ["stop"]),
                      key: el.JobId
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_unref(TirCheckbox), {
                          modelValue: el.IsSelect,
                          "onUpdate:modelValue": ($event: any) => ((el.IsSelect) = $event),
                          key: el.JobId
                        }, {
                          mainSign: _withCtx(() => [
                            _createTextVNode(_toDisplayString(el.JobName), 1)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"]))
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_unref(TirPmScrollbar), {
                "show-on-hover": true,
                style: { 'max-height': '30rem' }
              }, {
                default: _withCtx(() => [
                  _createVNode(PopoverOptionList, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noSelectJobs.value, (item) => {
                        return (_openBlock(), _createBlock(PopoverOptionLi, {
                          onClick: _withModifiers(($event: any) => (onSelectJob(item)), ["stop"]),
                          key: item.JobId
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_unref(TirCheckbox), {
                              value: item.IsSelect,
                              key: item.JobId
                            }, {
                              mainSign: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.JobName), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(TirCheckbox), {
            style: {"margin-right":"0.5rem"},
            "model-value": onlyError.value,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((onlyError).value = $event)),
              onOnlyError
            ]
          }, {
            mainSign: _withCtx(() => [
              _createTextVNode("Показать только с ошибками")
            ]),
            _: 1
          }, 8, ["model-value"]),
          _createVNode(_unref(TirPmButton), {
            size: _unref(TirPmButtonSizeEnum).Small,
            onClick: zoomOut
          }, {
            leftSlot: _withCtx(() => [
              _createVNode(_unref(MinusIcon))
            ]),
            _: 1
          }, 8, ["size"]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(Math.round(zoomLevel.value * 100)) + "%", 1),
          _createVNode(_unref(TirPmButton), {
            size: _unref(TirPmButtonSizeEnum).Small,
            onClick: zoomIn
          }, {
            leftSlot: _withCtx(() => [
              _createVNode(_unref(PlusIcon))
            ]),
            _: 1
          }, 8, ["size"])
        ])
      ]),
      _createElementVNode("div", {
        class: "gantt-wrapper",
        ref_key: "wrapper",
        ref: wrapper
      }, [
        _createElementVNode("canvas", {
          ref_key: "canvas",
          ref: canvas,
          onMousemove: handleMouseMove,
          onMouseleave: handleMouseLeave,
          onWheel: handleWheel,
          onClick: handleClick
        }, null, 544),
        (hoveredTask.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "tooltip",
              style: _normalizeStyle(tooltipStyle.value)
            }, [
              _createElementVNode("span", {
                class: "tooltip-color",
                style: _normalizeStyle({
            backgroundColor: STATUS_COLORS[hoveredTask.value.Status] || '#ccc',
          })
              }, null, 4),
              _createTextVNode(" " + _toDisplayString(getStatusName(hoveredTask.value.Status)) + ": " + _toDisplayString(hoveredTask.value.JobName || "test"), 1)
            ], 4))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _createElementVNode("div", {
      class: "resize-handle mt-8",
      onMousedown: startResize
    }, null, 32)
  ], 64))
}
}

})